import { useCallback, useEffect, useState } from 'react';
import type { CartStoreType } from '@store/CartStore';

type PickupPoint = {
  id: number;
  title?: string;
  type?: string;
  address?: string;
  schedule?: any;
  point?: any;
  nearestAvailableInterval?: any;
  [key: string]: any;
};

const usePickupPoints = (cartStore: CartStoreType): PickupPoint[] => {
  const [pickupPointsList, setPickupPointsList] = useState<PickupPoint[]>([]);

  const loadPP = useCallback(() => {
    cartStore
      .getPickupPoints()
      .then((res: any) => {
        setPickupPointsList(res.pickupPoints || []);
      })
      .catch(() => {});
  }, [cartStore]);

  useEffect(() => {
    loadPP();
  }, [loadPP]);

  return pickupPointsList;
};

export default usePickupPoints;
